<template>
  <el-dialog title="选择导出格式" :visible.sync="disableDialog" width="460px">
    <el-radio-group v-model="radio" style="margin-left:30px">
      <el-radio :class="radio==='1'?'radio-item act':'radio-item'" label="1">导出Excel格式</el-radio>
      <el-radio
        :class="radio==='2'?'radio-item act':'radio-item'"
        style="margin-top:20px"
        label="2"
      >导出PDF格式</el-radio>
    </el-radio-group>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { enquiryCoeDerive } from '@/api/sell/sellManage'
import { downLoadFileBlob } from '@/util/tool'
export default {
  data () {
    return {
      list: [],
      disableDialog: false,
      radio: null
    }
  },
  methods: {
    // 初始
    onInitial (arr) {
      this.list = arr
      this.radio = null
      this.disableDialog = true
    },
    // 确定
    onSubmit () {
      if (!this.radio) {
        this.$message.error('请选择下载格式！')
      } else {
        const params = {
          obId: this.$route.query.id,
          orderUrl:
            this.radio === '1'
              ? this.$store.state.sellGuidInExcel
              : this.$store.state.sellGuidIn,
          productBaseSelectsVoList: []
        }
        this.list.forEach((ele) => {
          const obj = {
            ocPrice: ele.ocPrice,
            bbId: ele.brandId,
            bsId: ele.seriesId,
            extimeValue: ele.ocExtime,
            productPrice: ele.ocFacePrice,
            count: ele.ocNeednumber,
            productName: ele.proName,
            productModel: ele.proType,
            proUnit: ele.ocUnit,
            brandName: ele.brandName,
            orderNumber: ele.orderNumber,
            proId: ele.proId,
            seriesName: ele.seriesName,
            mark: ele.mark
          }
          params.productBaseSelectsVoList.push(obj)
        })
        const str =
          this.radio === '1' ? 'enquiryExcelCoeDerive' : 'enquiryCoeDerive'
        enquiryCoeDerive(params, str).then((res) => {
          downLoadFileBlob(this, res)
        })
        if (this.radio === '1') {
        } else {
        }
        this.disableDialog = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-item {
  color: #4e555b;
  width: 282px;
  padding: 19px 20px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.radio-item:hover {
  box-shadow: 0px 2px 4px 0px #276cff03;
  border-radius: 4px;
  border: 1px solid #276cff;
}
.act {
  border: 1px solid #276cff;
}
</style>
